module.exports = __webpack_public_path__ + "img/galery-inge-v6-2.f1e3eccd.jpg";